import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token, isMultipart = false) => {
  const authToken = token || null;
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
  if (isMultipart) {
    return {
      ...headers,
      "Content-Type": "multipart/form-data",
    };
  }
  return {
    ...headers,
    "Content-Type": "application/json",
  };
};

export async function submitBugReport(formData, token) {
  const res = await axios.post(`${API}/bug-reports`, formData, {
    headers: authHeaders(token, true),
  });
  return res.data;
}

export async function listMyBugReports(token, limit = 5) {
  const res = await axios.get(`${API}/bug-reports/mine`, {
    params: { limit },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getSuperAdminBugReportFilters(token) {
  const res = await axios.get(`${API}/superadmin/bug-reports/filters`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listSuperAdminBugReports(payload, token) {
  const res = await axios.post(`${API}/superadmin/bug-reports/list`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getSuperAdminBugReportSummary(token) {
  const res = await axios.get(`${API}/superadmin/bug-reports/summary`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateSuperAdminBugReport(id, payload, token) {
  const res = await axios.patch(`${API}/superadmin/bug-reports/${id}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
